var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgShareapplereact = function SvgShareapplereact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.966 3.194c.687-.846 1.15-2.021 1.024-3.194-.989.041-2.186.67-2.894 1.518-.636.747-1.192 1.944-1.04 3.093 1.097.086 2.225-.572 2.91-1.417m4.512 3.633c-.162.1-2.14 1.317-2.116 3.8.028 3.022 2.605 4.028 2.638 4.041l-.007.022a11.3 11.3 0 0 1-1.351 2.825c-.82 1.219-1.669 2.432-3.008 2.459-.643.012-1.073-.178-1.52-.375-.467-.207-.954-.421-1.723-.421-.804 0-1.313.22-1.803.433-.425.185-.836.363-1.415.387-1.295.05-2.276-1.317-3.103-2.53-1.69-2.483-2.98-7.02-1.25-10.074.861-1.52 2.4-2.482 4.068-2.506.72-.015 1.415.266 2.025.512.466.188.881.356 1.218.356.302 0 .706-.162 1.178-.352.741-.298 1.649-.662 2.583-.565.64.027 2.437.263 3.594 1.984z",
    clipRule: "evenodd"
  })));
};
export default SvgShareapplereact;